import { RiskLevel } from './types';

export function getRiskLevel(riskFactor: number): RiskLevel {
  if (riskFactor <= 0.7) {
    return 'low';
  }

  if (riskFactor > 0.7 && riskFactor <= 0.85) {
    return 'medium';
  }

  return 'high';
}
